import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Icon from '@salesforce/design-system-react/components/icon';
import EventStatusBadge from '../../../Shared/EventStatusBadge';
import SubmissionInFlightIcon from '../../../Shared/SubmissionInFlightIcon';
import { INVENTORY_REQUEST_DETAIL_UI } from '../../../../util/constants';
import {
  shouldShowSubmissionInFlight,
  SubmissionStatusRecord,
} from '../../../../util/submissionStatus';

interface Status {
  status: string;
  visualIndicator: string;
  submissionStatusRecord?: SubmissionStatusRecord | null;
}
export interface Props {
  children?: FC;
  item?: Status;
}

const ReturnStatusCell: FC<Props> = ({
  item = {
    status: '',
    visualIndicator: '',
    submissionStatusRecord: null,
  },
}) => {
  const { status, visualIndicator, submissionStatusRecord } = item;
  const isSubmissionInFlight = shouldShowSubmissionInFlight(
    submissionStatusRecord || undefined,
    INVENTORY_REQUEST_DETAIL_UI.SUBMISSION_RECOVERY_MAX_AGE_MS
  );

  let statusToShow = visualIndicator;

  if (visualIndicator === 'Rejected' || visualIndicator === 'Approved') {
    statusToShow = status;
  } else if (
    status === 'Failed' &&
    (visualIndicator === 'Failed' || visualIndicator === 'Closed')
  ) {
    statusToShow = 'Approved';
  }
  return (
    <IconSettings iconPath="/icons">
      <DataTableCell title={statusToShow || 'NEW'}>
        <div style={{ display: 'flex' }}>
          <EventStatusBadge status={statusToShow || 'NEW'} />
          {status === 'Requested' && visualIndicator === 'Rejected' && (
            <div style={{ marginLeft: '5px' }}>
              <Icon
                title="Rejected"
                category="utility"
                name="warning"
                size="x-small"
                style={{ color: '#b83c27' }}
                className="slds-icon-text-error"
              />
            </div>
          )}
          {isSubmissionInFlight && <SubmissionInFlightIcon />}
        </div>
      </DataTableCell>
    </IconSettings>
  );
};

export default ReturnStatusCell;
